export function copyAndRenameFile(file, newName) {
	return new File([file], newName);
}
